/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CachedTokenListInfo } from '../../models/cached-token-list-info';

export interface ApiSupportCachedGet$Params {
}

export function apiSupportCachedGet(http: HttpClient, rootUrl: string, params?: ApiSupportCachedGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CachedTokenListInfo>>> {
  const rb = new RequestBuilder(rootUrl, apiSupportCachedGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CachedTokenListInfo>>;
    })
  );
}

apiSupportCachedGet.PATH = '/api/support/cached';
